import moment from "moment";
import { isCaregiverMemoryImprovementsEnabled } from "@medflyt/webapp-react/src/modules/betaFeatures/betaFeatures.store";
import { mergeChatSearchRows } from "../utils/chat-caregivers";

export const entityChatsListComponent = {
  templateUrl: "admin/views/entity-chats-list-component.html",
  bindings: {
    entity: "<",
    chats: "<",
    onChatClick: "&",
  },
  //! @ngInject
  controller: function ($rootScope, DatabaseApi) {
    this.useCaregiverSearch = isCaregiverMemoryImprovementsEnabled();
    this.searchMatches = [];
    this.visibleChats = [];
    let version = 0;
    this.$onChanges = () => { this.visibleChats = mergeChatSearchRows(this.chats || [], this.searchMatches); };
    this.$onDestroy = () => { version++; };
    this.searchCaregivers = () => {
      if (!this.useCaregiverSearch) return;
      const request = ++version;
      this.searchError = null;
      return DatabaseApi.searchChatCaregivers(this.filter.displayName || "").then((matches) => {
        if (request !== version) return;
        this.searchMatches = matches;
        this.visibleChats = mergeChatSearchRows(this.chats || [], matches);
      }, () => {
        if (request !== version) return;
        this.searchMatches = [];
        this.visibleChats = this.chats || [];
        this.searchError = "Unable to search caregivers. Please try again.";
      });
    };
    this.filter = { displayName: "" };
    this.orderByArr = { radio: "", val: "" };
    this.selectChat = (chat) => {
      if (chat.chatRoomType === undefined) {
        chat.fromList = true;
        chat.chatRoomType = {
          caregiverId: chat.id,
          patientId: this.entity ? this.entity.id : null,
        };
      }
      this.onChatClick({ chat });
    };

    const fuzzy_match = (str, pattern) => {
      pattern = pattern.split("").reduce(function (a, b) {
        return a + "[^" + b + "]*" + b;
      });
      var regx;
      try {
        regx = new RegExp(pattern);
      } catch (e) { }
      if (regx) return regx.test(str);
      else return false;
    };

    this.isToday = (date) => {
      const now = moment().subtract(24, 'h');
      const expirationDate = moment(date);
      return expirationDate.diff(now, 'h') > 0;
    }

    this.fuzzyFilter = (row) => {
      // console.log("row=", row);
      if (
        this.filter.myMessagesOnly &&
        (!row ||
          !row.chat ||
          row.chat.chatRoomType.agencyMemberId !== $rootScope.agencyMemberId)
      )
        return false;
      if (
        !this.filter.displayName &&
        (!row || !row.chat || !row.chat.messages || !row.chat.messages.length)
      )
        return false;
      if (!this.filter || !this.filter.displayName) return true;
      if (row.displayId && fuzzy_match(row.displayId.toString().toLocaleLowerCase(), this.filter.displayName.toLocaleLowerCase())) return true;
      if (
        fuzzy_match(
          row.displayName.toLocaleLowerCase(),
          this.filter.displayName.toLocaleLowerCase()
        )
      )
        return true;
      if (
        row.caregiverCode &&
        fuzzy_match(
          row.caregiverCode.toLocaleLowerCase(),
          this.filter.displayName.toLocaleLowerCase()
        )
      )
        return true;
      return false;
    };
  },
};
